import React from 'react';

import { EmptyLayout } from '.';

export const SingleLayout = ({ title, description, image, children, ...rest }) => (
  <EmptyLayout title={title} description={description} image={image} {...rest}>
    {children}
  </EmptyLayout>
);
